// @ts-nocheck

export enum SupportedTypes {
    String = "String",
    Tinyint = "Tinyint",
    Smallint = "Smallint",
    Int = "Int",
    Bigint = "Bigint",
    Decimal = "Decimal",
    Bool = "Bool",
    Datetime = "Datetime",
    GUID = "GUID",
    Timespan = "Timespan",
    Quantity = "Quantity"
}

export enum TagAcquisitionMode {
    CyclicContinuous = "CyclicContinuous",
    Undefined = "Undefined",
    OnChange = "OnChange"
}

export enum TagSmoothingMode {
    Value = "Value",
    None = "None"
}

export enum DataType {
    Bool = "Bool",
    Int = "Int",
    DInt = "DInt",
    LInt = "LInt",
    LReal = "LReal",
    Datetime = "Datetime",
    String = "String",
    Byte = "Byte",
    SInt = "SInt",
    Real = "Real",
    UInt = "UInt",
    UDInt = "UDInt",
    ULInt = "ULInt"
}

export enum TagDateTimeKind {
    Unspecified = "Unspecified",
    Local = "Local",
    Utc = "Utc"
}

export enum TagAddressType {
    NodeId = "NodeId",
    BrowsePath = "BrowsePath"
}

export enum ConnectionType {
    OPCUA = "OPCUA"
}

export enum SecurityPolicy {
    None = "None",
    Basic128Rsa15 = "Basic128Rsa15",
    Basic256 = "Basic256",
    Basic256Sha256 = "Basic256Sha256"
}

export enum MessageSecurityMode {
    None = "None",
    Sign = "Sign",
    SignAndEncrypt = "SignAndEncrypt"
}

export enum ConnectionFamilyType {
    Undefined = "Undefined",
    S7_1200 = "S7_1200",
    S7_1500 = "S7_1500"
}

export enum IdentityTokenType {
    Anonymous = "Anonymous",
    UsernamePassword = "UsernamePassword"
}

export enum ActivationFamilyType {
    TypesAndInstances = "TypesAndInstances",
    Channels = "Channels",
    ResetConfiguration = "ResetConfiguration"
}

export enum ImportMode {
    Reset = "Reset",
    Replace = "Replace",
    Preserve = "Preserve"
}

export enum TimeStampMode {
    None = "None",
    Source = "Source",
    Server = "Server",
    Both = "Both"
}

export enum ParameterType {
    Scalar = "Scalar",
    Array = "Array"
}

export enum ServerRedundancyFailoverMode {
    None = "None",
    HotA = "HotA"
}

export enum SupportedTypes2 {
    String = "String",
    Tinyint = "Tinyint",
    Smallint = "Smallint",
    Int = "Int",
    Bigint = "Bigint",
    Decimal = "Decimal",
    Bool = "Bool",
    Datetime = "Datetime",
    GUID = "GUID",
    Timespan = "Timespan",
    Quantity = "Quantity"
}

export enum StatusesOutcome {
    NoOutcome = "NoOutcome",
    Success = "Success",
    Failure = "Failure",
    Skip = "Skip"
}

export enum LinkType {
    Never = "Never",
    IfAvailable = "IfAvailable",
    Always = "Always"
}

export enum MigrationLogLevel {
    Critical = "Critical",
    Error = "Error",
    Warning = "Warning",
    Informational = "Informational",
    Verbose = "Verbose"
}

export enum PrimitiveTypes {
    String = "String",
    Tinyint = "Tinyint",
    Smallint = "Smallint",
    Int = "Int",
    Bigint = "Bigint",
    Decimal = "Decimal",
    Bool = "Bool",
    Datetime = "Datetime",
    GUID = "GUID",
    Timespan = "Timespan"
}

export enum ApplicationLogLevelType {
    Critical = "Critical",
    Error = "Error",
    Warning = "Warning",
    Informational = "Informational",
    Verbose = "Verbose"
}

export enum AutomationDataTypeEnum {
    Bool = "Bool",
    Int = "Int",
    DInt = "DInt",
    LInt = "LInt",
    LReal = "LReal",
    Datetime = "Datetime",
    String = "String",
    Byte = "Byte",
    SInt = "SInt",
    Real = "Real",
    UInt = "UInt",
    UDInt = "UDInt",
    ULInt = "ULInt"
}

export enum SegregationTagStatus {
    Available = "Available",
    Locked = "Locked"
}

export enum TimerModeEnum {
    OneShot = "OneShot",
    Periodic = "Periodic"
}

export enum TimerTypeEnum {
    Delay = "Delay",
    SpecificTime = "SpecificTime"
}

export interface LogMessageCatalog {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Owner` |
     * | Type | `Edm.String` |
     */
    Owner: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LanguageCode` |
     * | Type | `Edm.String` |
     */
    LanguageCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ShortMessage` |
     * | Type | `Edm.String` |
     */
    ShortMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LongMessage` |
     * | Type | `Edm.String` |
     */
    LongMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MessageId` |
     * | Type | `Edm.Int32` |
     */
    MessageId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.Types.ReadingModel.ApplicationLogLevelType` |
     */
    Level: ApplicationLogLevelType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalogParameters` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalogParameters)` |
     */
    LogMessageCatalogParameters?: Array<LogMessageCatalogParameters>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalogLanguages` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalogLanguages)` |
     */
    LogMessageCatalogLanguages?: Array<LogMessageCatalogLanguages>;
}

export type LogMessageCatalogId = string | {Id: string};

export interface LogMessageCatalogParameters {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterKey` |
     * | Type | `Edm.String` |
     */
    ParameterKey: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Edm.String` |
     */
    ParameterType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog_Id` |
     * | Type | `Edm.Guid` |
     */
    LogMessageCatalog_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalog` |
     */
    LogMessageCatalog?: LogMessageCatalog | null;
}

export type LogMessageCatalogParametersId = string | {Id: string};

export interface LogMessageCatalogLanguages {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LanguageCode` |
     * | Type | `Edm.String` |
     */
    LanguageCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ShortMessage` |
     * | Type | `Edm.String` |
     */
    ShortMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LongMessage` |
     * | Type | `Edm.String` |
     */
    LongMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog_Id` |
     * | Type | `Edm.Guid` |
     */
    LogMessageCatalog_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalog` |
     */
    LogMessageCatalog?: LogMessageCatalog | null;
}

export type LogMessageCatalogLanguagesId = string | {Id: string};

export interface File {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PayloadSize` |
     * | Type | `Edm.Int64` |
     */
    PayloadSize: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedBy` |
     * | Type | `Edm.String` |
     */
    CreatedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedBy` |
     * | Type | `Edm.String` |
     */
    LastUpdatedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Folder_Id` |
     * | Type | `Edm.Guid` |
     */
    Folder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Folder` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.Folder` |
     */
    Folder?: Folder | null;
}

export type FileId = string | {Id: string};

export interface Folder {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentFolder_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentFolder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentFolder` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.Folder` |
     */
    ParentFolder?: Folder | null;
}

export type FolderId = string | {Id: string};

export interface SegregationTag {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TagStatus` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.Types.ReadingModel.SegregationTagStatus` |
     */
    TagStatus: SegregationTagStatus | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLogRelevant` |
     * | Type | `Edm.Boolean` |
     */
    IsLogRelevant: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
}

export type SegregationTagId = string | {Id: string};

export interface EquipmentLevel {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentLevelFacet)` |
     */
    Facets?: Array<EquipmentLevelFacet>;
}

export type EquipmentLevelId = string | {Id: string};

export interface EquipmentStateMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Id` |
     * | Type | `Edm.Guid` |
     */
    Equipment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.Equipment` |
     */
    Equipment?: Equipment | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentStateMachineFacet)` |
     */
    Facets?: Array<EquipmentStateMachineFacet>;
}

export type EquipmentStateMachineId = string | {Id: string};

export interface EquipmentTypeStateMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentType` |
     */
    EquipmentType?: EquipmentType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentTypeStateMachineFacet)` |
     */
    Facets?: Array<EquipmentTypeStateMachineFacet>;
}

export type EquipmentTypeStateMachineId = string | {Id: string};

export interface EquipmentConfigurationStateMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfiguration` |
     */
    EquipmentConfiguration?: EquipmentConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfigurationStateMachineFacet)` |
     */
    Facets?: Array<EquipmentConfigurationStateMachineFacet>;
}

export type EquipmentConfigurationStateMachineId = string | {Id: string};

export interface EquipmentPropertyAttribute {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeValue` |
     * | Type | `Edm.String` |
     */
    AttributeValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    AttributeType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentProperty` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentProperty` |
     */
    EquipmentProperty?: EquipmentProperty | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentPropertyAttributeFacet)` |
     */
    Facets?: Array<EquipmentPropertyAttributeFacet>;
}

export type EquipmentPropertyAttributeId = string | {Id: string};

export interface EquipmentTypePropertyAttribute {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeValue` |
     * | Type | `Edm.String` |
     */
    AttributeValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    AttributeType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeProperty` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentTypeProperty` |
     */
    EquipmentTypeProperty?: EquipmentTypeProperty | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentTypePropertyAttributeFacet)` |
     */
    Facets?: Array<EquipmentTypePropertyAttributeFacet>;
}

export type EquipmentTypePropertyAttributeId = string | {Id: string};

export interface EquipmentConfigurationPropertyAttribute {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeValue` |
     * | Type | `Edm.String` |
     */
    AttributeValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    AttributeType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationProperty` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfigurationProperty` |
     */
    EquipmentConfigurationProperty?: EquipmentConfigurationProperty | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfigurationPropertyAttributeFacet)` |
     */
    Facets?: Array<EquipmentConfigurationPropertyAttributeFacet>;
}

export type EquipmentConfigurationPropertyAttributeId = string | {Id: string};

export interface EquipmentGraphType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphTypeFacet)` |
     */
    Facets?: Array<EquipmentGraphTypeFacet>;
}

export type EquipmentGraphTypeId = string | {Id: string};

export interface EquipmentGroup {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGroupConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.Equipment)` |
     */
    Equipment?: Array<Equipment>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGroupFacet)` |
     */
    Facets?: Array<EquipmentGroupFacet>;
}

export type EquipmentGroupId = string | {Id: string};

export interface EquipmentGraphNode {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentGraphConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphType` |
     * | Type | `Edm.String` |
     */
    EquipmentGraphType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupNId` |
     * | Type | `Edm.String` |
     */
    EquipmentGroupNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphNodeConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetX` |
     * | Type | `Edm.Int32` |
     */
    OffsetX: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetY` |
     * | Type | `Edm.Int32` |
     */
    OffsetY: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphNodeFacet)` |
     */
    Facets?: Array<EquipmentGraphNodeFacet>;
}

export type EquipmentGraphNodeId = string | {Id: string};

export interface EquipmentGraphLink {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourcePosition` |
     * | Type | `Edm.String` |
     */
    SourcePosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationPosition` |
     * | Type | `Edm.String` |
     */
    DestinationPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLinkConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphLinkConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source_Id` |
     * | Type | `Edm.Guid` |
     */
    Source_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Destination_Id` |
     * | Type | `Edm.Guid` |
     */
    Destination_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphNode` |
     */
    Source?: EquipmentGraphNode | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Destination` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphNode` |
     */
    Destination?: EquipmentGraphNode | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphLinkFacet)` |
     */
    Facets?: Array<EquipmentGraphLinkFacet>;
}

export type EquipmentGraphLinkId = string | {Id: string};

export interface EquipmentGraphNodeConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentGroupConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetX` |
     * | Type | `Edm.Int32` |
     */
    OffsetX: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetY` |
     * | Type | `Edm.Int32` |
     */
    OffsetY: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfiguration` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphConfiguration` |
     */
    EquipmentGraphConfiguration?: EquipmentGraphConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphNodeConfigurationFacet)` |
     */
    Facets?: Array<EquipmentGraphNodeConfigurationFacet>;
}

export type EquipmentGraphNodeConfigurationId = string | {Id: string};

export interface EquipmentGraphLinkConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourcePosition` |
     * | Type | `Edm.String` |
     */
    SourcePosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationPosition` |
     * | Type | `Edm.String` |
     */
    DestinationPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source_Id` |
     * | Type | `Edm.Guid` |
     */
    Source_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Destination_Id` |
     * | Type | `Edm.Guid` |
     */
    Destination_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphNodeConfiguration` |
     */
    Source?: EquipmentGraphNodeConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Destination` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphNodeConfiguration` |
     */
    Destination?: EquipmentGraphNodeConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphLinkConfigurationFacet)` |
     */
    Facets?: Array<EquipmentGraphLinkConfigurationFacet>;
}

export type EquipmentGraphLinkConfigurationId = string | {Id: string};

export interface EquipmentGraphConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type_Id` |
     * | Type | `Edm.Guid` |
     */
    Type_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphType` |
     */
    Type?: EquipmentGraphType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphConfigurationFacet)` |
     */
    Facets?: Array<EquipmentGraphConfigurationFacet>;
}

export type EquipmentGraphConfigurationId = string | {Id: string};

export interface EquipmentGroupConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurations` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfiguration)` |
     */
    EquipmentConfigurations?: Array<EquipmentConfiguration>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationParents` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGroupConfiguration)` |
     */
    EquipmentGroupConfigurationParents?: Array<EquipmentGroupConfiguration>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationChildren` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGroupConfiguration)` |
     */
    EquipmentGroupConfigurationChildren?: Array<EquipmentGroupConfiguration>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGroupConfigurationFacet)` |
     */
    Facets?: Array<EquipmentGroupConfigurationFacet>;
}

export type EquipmentGroupConfigurationId = string | {Id: string};

export interface StatusTransition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Verb` |
     * | Type | `Edm.String` |
     */
    Verb: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DoRaiseEvent` |
     * | Type | `Edm.Boolean` |
     */
    DoRaiseEvent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetStatus_Id` |
     * | Type | `Edm.Guid` |
     */
    TargetStatus_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceStatus_Id` |
     * | Type | `Edm.Guid` |
     */
    SourceStatus_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetStatus` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.Status` |
     */
    TargetStatus?: Status | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceStatus` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.Status` |
     */
    SourceStatus?: Status | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.StatusTransitionFacet)` |
     */
    Facets?: Array<StatusTransitionFacet>;
}

export type StatusTransitionId = string | {Id: string};

export interface Status {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInitial` |
     * | Type | `Edm.Boolean` |
     */
    IsInitial: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Outcome` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusesOutcome` |
     */
    Outcome: StatusesOutcome | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    StateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceStatusTransitions` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.StatusTransition)` |
     */
    SourceStatusTransitions?: Array<StatusTransition>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetStatusTransitions` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.StatusTransition)` |
     */
    TargetStatusTransitions?: Array<StatusTransition>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.StateMachine` |
     */
    StateMachine?: StateMachine | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.StatusFacet)` |
     */
    Facets?: Array<StatusFacet>;
}

export type StatusId = string | {Id: string};

export interface StateMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Statuses` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.Status)` |
     */
    Statuses?: Array<Status>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.StateMachineFacet)` |
     */
    Facets?: Array<StateMachineFacet>;
}

export type StateMachineId = string | {Id: string};

export interface EquipmentProperty {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    PropertyType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Id` |
     * | Type | `Edm.Guid` |
     */
    Equipment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyAttributes` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentPropertyAttribute)` |
     */
    EquipmentPropertyAttributes?: Array<EquipmentPropertyAttribute>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.Equipment` |
     */
    Equipment?: Equipment | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentPropertyFacet)` |
     */
    Facets?: Array<EquipmentPropertyFacet>;
}

export type EquipmentPropertyId = string | {Id: string};

export interface Equipment {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkCalendarNId` |
     * | Type | `Edm.String` |
     */
    WorkCalendarNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachines` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentStateMachine)` |
     */
    StateMachines?: Array<EquipmentStateMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroups` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGroup)` |
     */
    EquipmentGroups?: Array<EquipmentGroup>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentProperties` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentProperty)` |
     */
    EquipmentProperties?: Array<EquipmentProperty>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentFacet)` |
     */
    Facets?: Array<EquipmentFacet>;
}

export type EquipmentId = string | {Id: string};

export interface EquipmentTypeProperty {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    PropertyType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypePropertyAttributes` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentTypePropertyAttribute)` |
     */
    EquipmentTypePropertyAttributes?: Array<EquipmentTypePropertyAttribute>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentType` |
     */
    EquipmentType?: EquipmentType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentTypePropertyFacet)` |
     */
    Facets?: Array<EquipmentTypePropertyFacet>;
}

export type EquipmentTypePropertyId = string | {Id: string};

export interface EquipmentType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachines` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentTypeStateMachine)` |
     */
    StateMachines?: Array<EquipmentTypeStateMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeProperties` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentTypeProperty)` |
     */
    EquipmentTypeProperties?: Array<EquipmentTypeProperty>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentTypeFacet)` |
     */
    Facets?: Array<EquipmentTypeFacet>;
}

export type EquipmentTypeId = string | {Id: string};

export interface EquipmentConfigurationProperty {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    PropertyType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyAttributes` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfigurationPropertyAttribute)` |
     */
    EquipmentConfigurationPropertyAttributes?: Array<EquipmentConfigurationPropertyAttribute>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfiguration` |
     */
    EquipmentConfiguration?: EquipmentConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfigurationPropertyFacet)` |
     */
    Facets?: Array<EquipmentConfigurationPropertyFacet>;
}

export type EquipmentConfigurationPropertyId = string | {Id: string};

export interface EquipmentConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachines` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfigurationStateMachine)` |
     */
    StateMachines?: Array<EquipmentConfigurationStateMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurations` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGroupConfiguration)` |
     */
    EquipmentGroupConfigurations?: Array<EquipmentGroupConfiguration>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationProperties` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfigurationProperty)` |
     */
    EquipmentConfigurationProperties?: Array<EquipmentConfigurationProperty>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfigurationFacet)` |
     */
    Facets?: Array<EquipmentConfigurationFacet>;
}

export type EquipmentConfigurationId = string | {Id: string};

export interface EquipmentLevelFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentLevel_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentLevel_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentLevel` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentLevel` |
     */
    EquipmentLevel?: EquipmentLevel | null;
}

export type EquipmentLevelFacetId = string | {Id: string};

export interface EquipmentStateMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentStateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentStateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentStateMachine` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentStateMachine` |
     */
    EquipmentStateMachine?: EquipmentStateMachine | null;
}

export type EquipmentStateMachineFacetId = string | {Id: string};

export interface EquipmentTypeStateMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeStateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeStateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeStateMachine` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentTypeStateMachine` |
     */
    EquipmentTypeStateMachine?: EquipmentTypeStateMachine | null;
}

export type EquipmentTypeStateMachineFacetId = string | {Id: string};

export interface EquipmentConfigurationStateMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationStateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationStateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationStateMachine` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfigurationStateMachine` |
     */
    EquipmentConfigurationStateMachine?: EquipmentConfigurationStateMachine | null;
}

export type EquipmentConfigurationStateMachineFacetId = string | {Id: string};

export interface EquipmentPropertyAttributeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyAttribute_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentPropertyAttribute_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyAttribute` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentPropertyAttribute` |
     */
    EquipmentPropertyAttribute?: EquipmentPropertyAttribute | null;
}

export type EquipmentPropertyAttributeFacetId = string | {Id: string};

export interface EquipmentTypePropertyAttributeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypePropertyAttribute_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypePropertyAttribute_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypePropertyAttribute` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentTypePropertyAttribute` |
     */
    EquipmentTypePropertyAttribute?: EquipmentTypePropertyAttribute | null;
}

export type EquipmentTypePropertyAttributeFacetId = string | {Id: string};

export interface EquipmentConfigurationPropertyAttributeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyAttribute_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationPropertyAttribute_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyAttribute` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfigurationPropertyAttribute` |
     */
    EquipmentConfigurationPropertyAttribute?: EquipmentConfigurationPropertyAttribute | null;
}

export type EquipmentConfigurationPropertyAttributeFacetId = string | {Id: string};

export interface EquipmentGraphTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphType_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphType` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphType` |
     */
    EquipmentGraphType?: EquipmentGraphType | null;
}

export type EquipmentGraphTypeFacetId = string | {Id: string};

export interface EquipmentGroupFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroup_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGroup_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroup` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGroup` |
     */
    EquipmentGroup?: EquipmentGroup | null;
}

export type EquipmentGroupFacetId = string | {Id: string};

export interface EquipmentGraphNodeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNode_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphNode_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNode` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphNode` |
     */
    EquipmentGraphNode?: EquipmentGraphNode | null;
}

export type EquipmentGraphNodeFacetId = string | {Id: string};

export interface EquipmentGraphLinkFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLink_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphLink_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLink` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphLink` |
     */
    EquipmentGraphLink?: EquipmentGraphLink | null;
}

export type EquipmentGraphLinkFacetId = string | {Id: string};

export interface EquipmentGraphNodeConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNodeConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphNodeConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNodeConfiguration` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphNodeConfiguration` |
     */
    EquipmentGraphNodeConfiguration?: EquipmentGraphNodeConfiguration | null;
}

export type EquipmentGraphNodeConfigurationFacetId = string | {Id: string};

export interface EquipmentGraphLinkConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLinkConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphLinkConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLinkConfiguration` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphLinkConfiguration` |
     */
    EquipmentGraphLinkConfiguration?: EquipmentGraphLinkConfiguration | null;
}

export type EquipmentGraphLinkConfigurationFacetId = string | {Id: string};

export interface EquipmentGraphConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfiguration` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGraphConfiguration` |
     */
    EquipmentGraphConfiguration?: EquipmentGraphConfiguration | null;
}

export type EquipmentGraphConfigurationFacetId = string | {Id: string};

export interface EquipmentGroupConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGroupConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfiguration` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentGroupConfiguration` |
     */
    EquipmentGroupConfiguration?: EquipmentGroupConfiguration | null;
}

export type EquipmentGroupConfigurationFacetId = string | {Id: string};

export interface StatusTransitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransition_Id` |
     * | Type | `Edm.Guid` |
     */
    StatusTransition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransition` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.StatusTransition` |
     */
    StatusTransition?: StatusTransition | null;
}

export type StatusTransitionFacetId = string | {Id: string};

export interface StatusFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status_Id` |
     * | Type | `Edm.Guid` |
     */
    Status_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.Status` |
     */
    Status?: Status | null;
}

export type StatusFacetId = string | {Id: string};

export interface StateMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    StateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.StateMachine` |
     */
    StateMachine?: StateMachine | null;
}

export type StateMachineFacetId = string | {Id: string};

export interface EquipmentPropertyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentProperty` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentProperty` |
     */
    EquipmentProperty?: EquipmentProperty | null;
}

export type EquipmentPropertyFacetId = string | {Id: string};

export interface EquipmentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Id` |
     * | Type | `Edm.Guid` |
     */
    Equipment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.Equipment` |
     */
    Equipment?: Equipment | null;
}

export type EquipmentFacetId = string | {Id: string};

export interface EquipmentTypePropertyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeProperty` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentTypeProperty` |
     */
    EquipmentTypeProperty?: EquipmentTypeProperty | null;
}

export type EquipmentTypePropertyFacetId = string | {Id: string};

export interface EquipmentTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentType` |
     */
    EquipmentType?: EquipmentType | null;
}

export type EquipmentTypeFacetId = string | {Id: string};

export interface EquipmentConfigurationPropertyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationProperty` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfigurationProperty` |
     */
    EquipmentConfigurationProperty?: EquipmentConfigurationProperty | null;
}

export type EquipmentConfigurationPropertyFacetId = string | {Id: string};

export interface EquipmentConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfiguration` |
     */
    EquipmentConfiguration?: EquipmentConfiguration | null;
}

export type EquipmentConfigurationFacetId = string | {Id: string};

export interface OPCUAConnect_EquipmentToAutomationNode {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Id` |
     * | Type | `Edm.Guid` |
     */
    Equipment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.Equipment` |
     */
    Equipment?: Equipment | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_EquipmentToAutomationNodeFacet)` |
     */
    Facets?: Array<OPCUAConnect_EquipmentToAutomationNodeFacet>;
}

export type OPCUAConnect_EquipmentToAutomationNodeId = string | {Id: string};

export interface OPCUAConnect_AutomationNode {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeId` |
     * | Type | `Edm.String` |
     */
    NodeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_AutomationNodeFacet)` |
     */
    Facets?: Array<OPCUAConnect_AutomationNodeFacet>;
}

export type OPCUAConnect_AutomationNodeId = string | {Id: string};

export interface OPCUAConnect_AutomationNodeInstance {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChannelNId` |
     * | Type | `Edm.String` |
     */
    ChannelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeType_Id` |
     * | Type | `Edm.Guid` |
     */
    AutomationNodeType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivationStatus` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    ActivationStatus: ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeType` |
     * | Type | `Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_AutomationNodeType` |
     */
    AutomationNodeType?: OPCUAConnect_AutomationNodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_AutomationNodeInstanceFacet)` |
     */
    Facets?: Array<OPCUAConnect_AutomationNodeInstanceFacet>;
}

export type OPCUAConnect_AutomationNodeInstanceId = string | {Id: string};

export interface OPCUAConnect_AutomationNodeType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivationStatus` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    ActivationStatus: ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstances` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_AutomationNodeInstance)` |
     */
    AutomationNodeInstances?: Array<OPCUAConnect_AutomationNodeInstance>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_AutomationNodeTypeFacet)` |
     */
    Facets?: Array<OPCUAConnect_AutomationNodeTypeFacet>;
}

export type OPCUAConnect_AutomationNodeTypeId = string | {Id: string};

export interface OPCUAConnect_EquipmentTypeToAutomationNodeType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentType` |
     */
    EquipmentType?: EquipmentType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_EquipmentTypeToAutomationNodeTypeFacet)` |
     */
    Facets?: Array<OPCUAConnect_EquipmentTypeToAutomationNodeTypeFacet>;
}

export type OPCUAConnect_EquipmentTypeToAutomationNodeTypeId = string | {Id: string};

export interface OPCUAConnect_EquipmentConfigurationToAutomationNodeInstance {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration` |
     * | Type | `Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.DataModel.ReadingModel.EquipmentConfiguration` |
     */
    EquipmentConfiguration?: EquipmentConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceFacet)` |
     */
    Facets?: Array<OPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceFacet>;
}

export type OPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceId = string | {Id: string};

export interface OPCUAConnect_EquipmentToAutomationNodeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_EquipmentToAutomationNode_Id` |
     * | Type | `Edm.Guid` |
     */
    OPCUAConnect_EquipmentToAutomationNode_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_EquipmentToAutomationNode` |
     * | Type | `Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_EquipmentToAutomationNode` |
     */
    OPCUAConnect_EquipmentToAutomationNode?: OPCUAConnect_EquipmentToAutomationNode | null;
}

export type OPCUAConnect_EquipmentToAutomationNodeFacetId = string | {Id: string};

export interface OPCUAConnect_AutomationNodeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_AutomationNode_Id` |
     * | Type | `Edm.Guid` |
     */
    OPCUAConnect_AutomationNode_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_AutomationNode` |
     * | Type | `Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_AutomationNode` |
     */
    OPCUAConnect_AutomationNode?: OPCUAConnect_AutomationNode | null;
}

export type OPCUAConnect_AutomationNodeFacetId = string | {Id: string};

export interface OPCUAConnect_AutomationNodeInstanceFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_AutomationNodeInstance_Id` |
     * | Type | `Edm.Guid` |
     */
    OPCUAConnect_AutomationNodeInstance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_AutomationNodeInstance` |
     * | Type | `Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_AutomationNodeInstance` |
     */
    OPCUAConnect_AutomationNodeInstance?: OPCUAConnect_AutomationNodeInstance | null;
}

export type OPCUAConnect_AutomationNodeInstanceFacetId = string | {Id: string};

export interface OPCUAConnect_AutomationNodeTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_AutomationNodeType_Id` |
     * | Type | `Edm.Guid` |
     */
    OPCUAConnect_AutomationNodeType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_AutomationNodeType` |
     * | Type | `Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_AutomationNodeType` |
     */
    OPCUAConnect_AutomationNodeType?: OPCUAConnect_AutomationNodeType | null;
}

export type OPCUAConnect_AutomationNodeTypeFacetId = string | {Id: string};

export interface OPCUAConnect_EquipmentTypeToAutomationNodeTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_EquipmentTypeToAutomationNodeType_Id` |
     * | Type | `Edm.Guid` |
     */
    OPCUAConnect_EquipmentTypeToAutomationNodeType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_EquipmentTypeToAutomationNodeType` |
     * | Type | `Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_EquipmentTypeToAutomationNodeType` |
     */
    OPCUAConnect_EquipmentTypeToAutomationNodeType?: OPCUAConnect_EquipmentTypeToAutomationNodeType | null;
}

export type OPCUAConnect_EquipmentTypeToAutomationNodeTypeFacetId = string | {Id: string};

export interface OPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_EquipmentConfigurationToAutomationNodeInstance_Id` |
     * | Type | `Edm.Guid` |
     */
    OPCUAConnect_EquipmentConfigurationToAutomationNodeInstance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OPCUAConnect_EquipmentConfigurationToAutomationNodeInstance` |
     * | Type | `Siemens.SimaticIT.Equipment.OPCUAConnect.EEPOMModel.DataModel.ReadingModel.OPCUAConnect_EquipmentConfigurationToAutomationNodeInstance` |
     */
    OPCUAConnect_EquipmentConfigurationToAutomationNodeInstance?: OPCUAConnect_EquipmentConfigurationToAutomationNodeInstance | null;
}

export type OPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceFacetId = string | {Id: string};

export interface ExecutionError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorCode` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    ErrorCode: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorMessage` |
     * | Type | `Edm.String` |
     */
    ErrorMessage: string | null;
}

export interface PrecheckExecution {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FullName` |
     * | Type | `Edm.String` |
     */
    FullName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Error` |
     * | Type | `Siemens.SimaticIT.Unified.Common.ExecutionError` |
     * | Nullable | `false` |
     */
    Error: ExecutionError;
}

export interface SitUafExecutionDetail {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrecheckDetails` |
     * | Type | `Collection(Siemens.SimaticIT.Unified.Common.PrecheckExecution)` |
     * | Nullable | `false` |
     */
    PrecheckDetails: Array<PrecheckExecution>;
}

export interface CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Succeeded` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Succeeded: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Error` |
     * | Type | `Siemens.SimaticIT.Unified.Common.ExecutionError` |
     * | Nullable | `false` |
     */
    Error: ExecutionError;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SitUafExecutionDetail` |
     * | Type | `Siemens.SimaticIT.Unified.Common.SitUafExecutionDetail` |
     */
    SitUafExecutionDetail: SitUafExecutionDetail | null;
}

export interface FunctionResponse extends CommandResponse {
}

export interface PreCheckResponse extends CommandResponse {
}

export interface ServiceLayerUnityError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `commandcallstack` |
     * | Type | `Collection(Edm.String)` |
     */
    commandcallstack: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `stacktrace` |
     * | Type | `Edm.String` |
     */
    stacktrace: string | null;
}

export interface ServiceLayerErrorObject {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `code` |
     * | Type | `Edm.String` |
     */
    code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `message` |
     * | Type | `Edm.String` |
     */
    message: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `innererror` |
     * | Type | `Siemens.SimaticIT.ServiceLayer.Core.ServiceLayerUnityError` |
     */
    innererror: ServiceLayerUnityError | null;
}

export interface ServiceLayerError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `error` |
     * | Type | `Siemens.SimaticIT.ServiceLayer.Core.ServiceLayerErrorObject` |
     */
    error: ServiceLayerErrorObject | null;
}

export interface DeleteEquipmentLevelsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeletedEquipmentLevels` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DeletedEquipmentLevels: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedEquipmentLevels` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedEquipmentLevels: Array<string>;
}

export interface DeleteEquipmentLevels {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface DeleteEquipmentTypesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeletedEquipmentTypes` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DeletedEquipmentTypes: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedEquipmentTypes` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedEquipmentTypes: Array<string>;
}

export interface DeleteEquipmentTypes {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface DeleteEquipmentConfigurationsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeletedEquipmentConfigurations` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DeletedEquipmentConfigurations: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedEquipmentConfigurations` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedEquipmentConfigurations: Array<string>;
}

export interface DeleteEquipmentConfigurations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface DeleteEquipmentGroupConfigurationsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeletedEquipmentGroupConfigurations` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DeletedEquipmentGroupConfigurations: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedEquipmentGroupConfigurations` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedEquipmentGroupConfigurations: Array<string>;
}

export interface DeleteEquipmentGroupConfigurations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface DeleteEquipmentGraphConfigurationsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeletedEquipmentGraphConfigurations` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DeletedEquipmentGraphConfigurations: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedEquipmentGraphConfigurations` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedEquipmentGraphConfigurations: Array<string>;
}

export interface DeleteEquipmentGraphConfigurations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UpdateEquipmentGraphConfigurationResponse extends CommandResponse {
}

export interface UpdateEquipmentGraphConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface AssociateChildrenEquipmentGroupConfWithEquipmentGroupConfResponse extends CommandResponse {
}

export interface AssociateChildrenEquipmentGroupConfWithEquipmentGroupConf {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGroupConfId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildEquipmentGroupConfIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ChildEquipmentGroupConfIds: Array<string>;
}

export interface AssociateEquipmentConfigurationsWithEquipmentGroupConfigurationResponse extends CommandResponse {
}

export interface AssociateEquipmentConfigurationsWithEquipmentGroupConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGroupConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationIds: Array<string>;
}

export interface SynchronizeEquipmentGraphResponse extends CommandResponse {
}

export interface SynchronizeEquipmentGraph {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
}

export interface BulkImportEquipmentGraphConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface BulkImportEquipmentGraphConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNodeConfigurations` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.EquipmentGraphNodeConfigurationParameterType)` |
     */
    EquipmentGraphNodeConfigurations: Array<EquipmentGraphNodeConfigurationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLinkConfigurations` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.EquipmentGraphLinkConfigurationParameterType)` |
     */
    EquipmentGraphLinkConfigurations: Array<EquipmentGraphLinkConfigurationParameterType>;
}

export interface AddEquipmentTypeStateMachinesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeStateMachineIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    EquipmentTypeStateMachineIds: Array<string>;
}

export interface AddEquipmentTypeStateMachines {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    StateMachineNIds: Array<string>;
}

export interface CreateEquipmentStateMachinesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentStateMachineIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    EquipmentStateMachineIds: Array<string>;
}

export interface CreateEquipmentStateMachines {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationStateMachineIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationStateMachineIds: Array<string>;
}

export interface DeleteEquipmentTypePropertyAttributeResponse extends CommandResponse {
}

export interface DeleteEquipmentTypePropertyAttribute {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateEquipmentPropertyAttributeResponse extends CommandResponse {
}

export interface UpdateEquipmentPropertyAttribute {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationPropertyNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyAttributeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationPropertyAttributeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyAttributeValue` |
     * | Type | `Edm.String` |
     */
    EquipmentConfigurationPropertyAttributeValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyAttributeOperational` |
     * | Type | `Edm.Boolean` |
     */
    EquipmentConfigurationPropertyAttributeOperational: boolean | null;
}

export interface SetEquipmentPropertyValueResponse extends CommandResponse {
}

export interface SetEquipmentPropertyValue {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentPropertyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyValue` |
     * | Type | `Edm.String` |
     */
    EquipmentPropertyValue: string | null;
}

export interface UnfreezeEquipmentLevelResponse extends CommandResponse {
}

export interface UnfreezeEquipmentLevel {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface FreezeEquipmentTypeResponse extends CommandResponse {
}

export interface FreezeEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateEquipmentGraphNodeResponse extends CommandResponse {
}

export interface UpdateEquipmentGraphNode {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGraphNodeConfigurationId: string;
}

export interface UpdateEquipmentGraphLinkResponse extends CommandResponse {
}

export interface UpdateEquipmentGraphLink {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLinkConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGraphLinkConfigurationId: string;
}

export interface DeleteEquipmentGroupConfigurationResponse extends CommandResponse {
}

export interface DeleteEquipmentGroupConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DisassociateParentsEquipmentGroupConfFromEquipmentGroupConfResponse extends CommandResponse {
}

export interface DisassociateParentsEquipmentGroupConfFromEquipmentGroupConf {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGroupConfId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentEquipmentGroupConfIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ParentEquipmentGroupConfIds: Array<string>;
}

export interface DeleteEquipmentTypePropertyResponse extends CommandResponse {
}

export interface DeleteEquipmentTypeProperty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AssociateParentsEquipmentGroupConfWithEquipmentGroupConfResponse extends CommandResponse {
}

export interface AssociateParentsEquipmentGroupConfWithEquipmentGroupConf {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGroupConfId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentEquipmentGroupConfIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ParentEquipmentGroupConfIds: Array<string>;
}

export interface UpdateEquipmentConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    PropertyIds: Array<string>;
}

export interface UpdateEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Properties` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyParameterType)` |
     */
    Properties: Array<PropertyParameterType>;
}

export interface UpdateEquipmentResponse extends CommandResponse {
}

export interface UpdateEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
}

export interface DisassociateEquipmentGroupConfigurationsFromEquipmentConfigurationResponse extends CommandResponse {
}

export interface DisassociateEquipmentGroupConfigurationsFromEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    EquipmentGroupConfigurationIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
}

export interface AddEquipmentConfigurationStateMachinesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationStateMachineIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationStateMachineIds: Array<string>;
}

export interface AddEquipmentConfigurationStateMachines {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    StateMachineNIds: Array<string>;
}

export interface DisassociateEquipmentConfigurationsFromEquipmentGroupConfigurationResponse extends CommandResponse {
}

export interface DisassociateEquipmentConfigurationsFromEquipmentGroupConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGroupConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationIds: Array<string>;
}

export interface SetEquipmentTypeAsDefaultResponse extends CommandResponse {
}

export interface SetEquipmentTypeAsDefault {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SetEquipmentStatusResponse extends CommandResponse {
}

export interface SetEquipmentStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Verb` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Verb: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentStateMachineId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentStateMachineId: string | null;
}

export interface FreezeEquipmentLevelResponse extends CommandResponse {
}

export interface FreezeEquipmentLevel {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteEquipmentStateMachineResponse extends CommandResponse {
}

export interface DeleteEquipmentStateMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentStateMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentStateMachineId: string;
}

export interface UpdateEquipmentTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    PropertyIds: Array<string>;
}

export interface UpdateEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Properties` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyParameterType)` |
     */
    Properties: Array<PropertyParameterType>;
}

export interface UpdateEquipmentGraphTypeResponse extends CommandResponse {
}

export interface UpdateEquipmentGraphType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface UpdateHierarchyEquipmentNodeConfigurationResponse extends CommandResponse {
}

export interface UpdateHierarchyEquipmentNodeConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    ParentEquipmentGraphNodeConfigurationId: string | null;
}

export interface CreateEquipmentLevelResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipConfLevelId` |
     * | Type | `Edm.Guid` |
     */
    EquipConfLevelId: string | null;
}

export interface CreateEquipmentLevel {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Level: number;
}

export interface CreateEquipmentGroupConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateEquipmentGroupConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
}

export interface SynchronizeEquipmentResponse extends CommandResponse {
}

export interface SynchronizeEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OverwriteRTValues` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    OverwriteRTValues: boolean;
}

export interface CreateEquipmentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentId: string | null;
}

export interface CreateEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
}

export interface UpdateEquipmentTypePropertyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    AttributeIds: Array<string>;
}

export interface UpdateEquipmentTypeProperty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     */
    PropertyType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attributes` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyParameterType)` |
     */
    Attributes: Array<PropertyParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface UpdateEquipmentConfigurationPropertyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    AttributeIds: Array<string>;
}

export interface UpdateEquipmentConfigurationProperty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attributes` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyParameterType)` |
     */
    Attributes: Array<PropertyParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface UnfreezeEquipmentGroupConfigurationResponse extends CommandResponse {
}

export interface UnfreezeEquipmentGroupConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateEquipmentGraphNodeConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateEquipmentGraphNodeConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGraphConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentGroupConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetX` |
     * | Type | `Edm.Int32` |
     */
    OffsetX: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetY` |
     * | Type | `Edm.Int32` |
     */
    OffsetY: number | null;
}

export interface CreateEquipmentGraphTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateEquipmentGraphType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface DeleteEquipmentGraphTypeResponse extends CommandResponse {
}

export interface DeleteEquipmentGraphType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateEquipmentLevelResponse extends CommandResponse {
}

export interface UpdateEquipmentLevel {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
}

export interface UpdateEquipmentTypePropertyAttributeResponse extends CommandResponse {
}

export interface UpdateEquipmentTypePropertyAttribute {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     */
    AttributeType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeValue` |
     * | Type | `Edm.String` |
     */
    AttributeValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface CreateEquipmentTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeId: string | null;
}

export interface CreateEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    StateMachineNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
}

export interface CreateEquipmentConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationId: string | null;
}

export interface CreateEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigStateMachineNids` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentConfigStateMachineNids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Properties` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyWithAttributesParameterType)` |
     */
    Properties: Array<PropertyWithAttributesParameterType>;
}

export interface UpdateEquipmentGraphLinkConfigurationResponse extends CommandResponse {
}

export interface UpdateEquipmentGraphLinkConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    SourceEquipmentGraphNodeConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    DestinationEquipmentGraphNodeConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourcePosition` |
     * | Type | `Edm.String` |
     */
    SourcePosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationPosition` |
     * | Type | `Edm.String` |
     */
    DestinationPosition: string | null;
}

export interface BulkImportEquipmentHierarchyResponse extends CommandResponse {
}

export interface BulkImportEquipmentHierarchy {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGraphConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Hierarchy` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Hierarchy: string;
}

export interface ForceEquipmentStatusResponse extends CommandResponse {
}

export interface ForceEquipmentStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentStateMachineId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentStateMachineId: string | null;
}

export interface SetEquipmentPropertyAttributeValueResponse extends CommandResponse {
}

export interface SetEquipmentPropertyAttributeValue {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyAttributeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentPropertyAttributeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyAttributeValue` |
     * | Type | `Edm.String` |
     */
    EquipmentPropertyAttributeValue: string | null;
}

export interface DeleteEquipmentLevelResponse extends CommandResponse {
}

export interface DeleteEquipmentLevel {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateEquipmentGraphLinkConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateEquipmentGraphLinkConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceEquipmentGraphNodeConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DestinationEquipmentGraphNodeConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourcePosition` |
     * | Type | `Edm.String` |
     */
    SourcePosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationPosition` |
     * | Type | `Edm.String` |
     */
    DestinationPosition: string | null;
}

export interface FreezeEquipmentConfigurationResponse extends CommandResponse {
}

export interface FreezeEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteHierarchyEquipmentNodeConfigurationResponse extends CommandResponse {
}

export interface DeleteHierarchyEquipmentNodeConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateEquipmentGroupResponse extends CommandResponse {
}

export interface UpdateEquipmentGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGroupConfigurationId: string;
}

export interface CreateHierarchyEquipmentNodeConfigurationsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNodeConfigurationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    EquipmentGraphNodeConfigurationIds: Array<string>;
}

export interface CreateHierarchyEquipmentNodeConfigurations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    ParentEquipmentGraphNodeConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurations` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentConfigurations: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphConfigurationId: string | null;
}

export interface SynchronizeEquipmentGroupResponse extends CommandResponse {
}

export interface SynchronizeEquipmentGroup {
}

export interface DeleteEquipmentTypeStateMachineResponse extends CommandResponse {
}

export interface DeleteEquipmentTypeStateMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeStateMachineId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeStateMachineId: string | null;
}

export interface CreateEquipmentGraphConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateEquipmentGraphConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
}

export interface UnfreezeEquipmentConfigurationResponse extends CommandResponse {
}

export interface UnfreezeEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteEquipmentTypeResponse extends CommandResponse {
}

export interface DeleteEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface FreezeEquipmentResponse extends CommandResponse {
}

export interface FreezeEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
}

export interface AssociateEquipmentGroupConfigurationsWithEquipmentConfigurationResponse extends CommandResponse {
}

export interface AssociateEquipmentGroupConfigurationsWithEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    EquipmentGroupConfigurationIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
}

export interface CreateEquipmentConfigurationByDefaultEquipmentTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationId: string | null;
}

export interface CreateEquipmentConfigurationByDefaultEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Properties` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyWithAttributesParameterType)` |
     */
    Properties: Array<PropertyWithAttributesParameterType>;
}

export interface UpdateEquipmentPropertyResponse extends CommandResponse {
}

export interface UpdateEquipmentProperty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationPropertyNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyValue` |
     * | Type | `Edm.String` |
     */
    EquipmentConfigurationPropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyOperational` |
     * | Type | `Edm.Boolean` |
     */
    EquipmentConfigurationPropertyOperational: boolean | null;
}

export interface UpdateEquipmentGroupConfigurationResponse extends CommandResponse {
}

export interface UpdateEquipmentGroupConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
}

export interface DeleteEquipmentConfigurationPropertyAttributeResponse extends CommandResponse {
}

export interface DeleteEquipmentConfigurationPropertyAttribute {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteEquipmentConfigurationStateMachineResponse extends CommandResponse {
}

export interface DeleteEquipmentConfigurationStateMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationStateMachineId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationStateMachineId: string | null;
}

export interface DeleteEquipmentGraphConfigurationResponse extends CommandResponse {
}

export interface DeleteEquipmentGraphConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteEquipmentResponse extends CommandResponse {
}

export interface DeleteEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentConfigurationNId: string | null;
}

export interface FreezeEquipmentGroupConfigurationResponse extends CommandResponse {
}

export interface FreezeEquipmentGroupConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteEquipmentGraphLinkConfigurationResponse extends CommandResponse {
}

export interface DeleteEquipmentGraphLinkConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteEquipmentPropertyAttributeResponse extends CommandResponse {
}

export interface DeleteEquipmentPropertyAttribute {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteEquipmentConfigurationResponse extends CommandResponse {
}

export interface DeleteEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteEquipmentConfigurationPropertyResponse extends CommandResponse {
}

export interface DeleteEquipmentConfigurationProperty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnfreezeEquipmentTypeResponse extends CommandResponse {
}

export interface UnfreezeEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DisassociateChildrenEquipmentGroupConfFromEquipmentGroupConfResponse extends CommandResponse {
}

export interface DisassociateChildrenEquipmentGroupConfFromEquipmentGroupConf {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGroupConfId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildEquipmentGroupConfIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ChildEquipmentGroupConfIds: Array<string>;
}

export interface UpdateEquipmentConfigurationPropertyAttributeResponse extends CommandResponse {
}

export interface UpdateEquipmentConfigurationPropertyAttribute {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeValue` |
     * | Type | `Edm.String` |
     */
    AttributeValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface UnfreezeEquipmentResponse extends CommandResponse {
}

export interface UnfreezeEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
}

export interface DeleteEquipmentGraphNodeConfigurationResponse extends CommandResponse {
}

export interface DeleteEquipmentGraphNodeConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SetEquipmentGraphConfigurationAsDefaultResponse extends CommandResponse {
}

export interface SetEquipmentGraphConfigurationAsDefault {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipGraphConfId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipGraphConfId: string;
}

export interface EquipmentGraphNodeConfigurationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentGroupConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetX` |
     * | Type | `Edm.Int32` |
     */
    OffsetX: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetY` |
     * | Type | `Edm.Int32` |
     */
    OffsetY: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeDeleted` |
     * | Type | `Edm.Boolean` |
     */
    ToBeDeleted: boolean | null;
}

export interface EquipmentGraphLinkConfigurationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceId` |
     * | Type | `Edm.String` |
     */
    SourceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationId` |
     * | Type | `Edm.String` |
     */
    DestinationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourcePosition` |
     * | Type | `Edm.String` |
     */
    SourcePosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationPosition` |
     * | Type | `Edm.String` |
     */
    DestinationPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeDeleted` |
     * | Type | `Edm.Boolean` |
     */
    ToBeDeleted: boolean | null;
}

export interface PropertyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     * | Nullable | `false` |
     */
    PropertyType: SupportedTypes;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface PropertyWithAttributesParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     * | Nullable | `false` |
     */
    PropertyType: SupportedTypes;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attributes` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyParameterType)` |
     */
    Attributes: Array<PropertyParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface OPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodesResponse extends CommandResponse {
}

export interface OPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodes {
}

export interface OPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfigurationResponse extends CommandResponse {
}

export interface OPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    AutomationNodeInstanceNIds: Array<string>;
}

export interface OPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfigurationResponse extends CommandResponse {
}

export interface OPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    AutomationNodeInstanceNIds: Array<string>;
}

export interface OPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentTypeResponse extends CommandResponse {
}

export interface OPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    AutomationNodeTypeNIds: Array<string>;
}

export interface OPCUAConnect_AssociateAutomationNodeTypesWithEquipmentTypeResponse extends CommandResponse {
}

export interface OPCUAConnect_AssociateAutomationNodeTypesWithEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    AutomationNodeTypeNIds: Array<string>;
}

export interface RF_GetEquipmentHierarchyResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentHierarchy` |
     * | Type | `Edm.String` |
     */
    EquipmentHierarchy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIds: Array<string>;
}

export interface RF_GetEquipmentHierarchy {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGraphConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentEquipmentNodeNId` |
     * | Type | `Edm.String` |
     */
    ParentEquipmentNodeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReturnOneLevel` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    ReturnOneLevel: boolean;
}

export interface RF_GetFilteredEquipmentConfigurationListResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationList` |
     * | Type | `Collection(Siemens.SimaticIT.Equipment.Equipment.EQPOMModel.Types.EquipmentConfigurationParameterType)` |
     */
    EquipmentConfigurationList: Array<EquipmentConfigurationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationsCount` |
     * | Type | `Edm.Int32` |
     */
    EquipmentConfigurationsCount: number | null;
}

export interface RF_GetFilteredEquipmentConfigurationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AddedNodesNId` |
     * | Type | `Collection(Edm.String)` |
     */
    AddedNodesNId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Page` |
     * | Type | `Edm.Int32` |
     */
    Page: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemsPerPage` |
     * | Type | `Edm.Int32` |
     */
    ItemsPerPage: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RemovedNodesNId` |
     * | Type | `Collection(Edm.String)` |
     */
    RemovedNodesNId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGraphConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Filter` |
     * | Type | `Edm.String` |
     */
    Filter: string | null;
}

export interface RF_GetStateMachineListResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
}

export interface RF_GetStateMachineList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationStateMachineId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationStateMachineId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeStateMachineId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeStateMachineId: string | null;
}

export interface GetEquipmentConfigurationsWithFilterResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
}

export interface GetEquipmentConfigurationsWithFilter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AddedNodesNId` |
     * | Type | `Collection(Edm.String)` |
     */
    AddedNodesNId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RemovedNodesNId` |
     * | Type | `Collection(Edm.String)` |
     */
    RemovedNodesNId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGraphConfigurationId: string;
}

export interface IQueryable {
}

export interface EquipmentConfigurationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
}

export interface OPCUAConnect_RF_GetAutomationNodesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AutomationNodeTypeNId: string;
}

export interface OPCUAConnect_RF_GetAutomationNodes {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface OPCUAConnect_RF_GetAutomationNodeTypesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsCurrent: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsLocked: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDeleted` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsDeleted: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivationStatus` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ActivationStatusParameterType` |
     */
    ActivationStatus: ActivationStatusParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UIStatus` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UIStatus: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAssociatedToEquipmentType` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsAssociatedToEquipmentType: boolean;
}

export interface OPCUAConnect_RF_GetAutomationNodeTypes {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HideAutomationNodeTypesAssociatedToEquipmentType` |
     * | Type | `Edm.Boolean` |
     */
    HideAutomationNodeTypesAssociatedToEquipmentType: boolean | null;
}

export interface OPCUAConnect_RF_GetAutomationNodeInstancesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsCurrent: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsLocked: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDeleted` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsDeleted: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivationStatus` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ActivationStatusParameterType` |
     */
    ActivationStatus: ActivationStatusParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UIStatus` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UIStatus: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AutomationNodeTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAssociatedToEquipmentConfiguration` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsAssociatedToEquipmentConfiguration: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAssociatedToEquipmentType` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsAssociatedToEquipmentType: boolean;
}

export interface OPCUAConnect_RF_GetAutomationNodeInstances {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HideAutomationNodeInstancesAssociatedToEquipmentConfiguration` |
     * | Type | `Edm.Boolean` |
     */
    HideAutomationNodeInstancesAssociatedToEquipmentConfiguration: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FilterByEquipmentType` |
     * | Type | `Edm.Boolean` |
     */
    FilterByEquipmentType: boolean | null;
}

export interface ActivationStatusParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dirty` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Dirty: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Activated` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Activated: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ready` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Ready: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dismissed` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Dismissed: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfirmedOn` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    ConfirmedOn: string;
}

export interface BaseResponse extends CommandResponse {
}

export interface ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dirty` |
     * | Type | `Edm.Boolean` |
     */
    Dirty: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Activated` |
     * | Type | `Edm.Boolean` |
     */
    Activated: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ready` |
     * | Type | `Edm.Boolean` |
     */
    Ready: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dismissed` |
     * | Type | `Edm.Boolean` |
     */
    Dismissed: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfirmedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ConfirmedOn: string | null;
}

export interface TagAspectType_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChannelNId` |
     * | Type | `Edm.String` |
     */
    ChannelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Address` |
     * | Type | `Edm.String` |
     */
    Address: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AcquisitionCycleNId` |
     * | Type | `Edm.String` |
     */
    AcquisitionCycleNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeltaValue` |
     * | Type | `Edm.Int64` |
     */
    DeltaValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SmoothingMode` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.TagSmoothingMode` |
     */
    SmoothingMode: TagSmoothingMode | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AcquisitionMode` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.TagAcquisitionMode` |
     */
    AcquisitionMode: TagAcquisitionMode | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AddressType` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.TagAddressType` |
     */
    AddressType: TagAddressType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Delta` |
     * | Type | `Edm.Decimal` |
     */
    Delta: number | null;
}

export interface QuantityType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QuantityValue` |
     * | Type | `Edm.Decimal` |
     */
    QuantityValue: number | null;
}

export interface StatusType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
}

export interface RF_GetEquipmentHierarchy2Params {
    function?: RF_GetEquipmentHierarchy | null;
}

export interface RF_GetFilteredEquipmentConfigurationList2Params {
    function?: RF_GetFilteredEquipmentConfigurationList | null;
}

export interface RF_GetStateMachineList2Params {
    function?: RF_GetStateMachineList | null;
}

export interface OPCUAConnect_RF_GetAutomationNodes2Params {
    function?: OPCUAConnect_RF_GetAutomationNodes | null;
}

export interface GetEquipmentConfigurationsWithFilter2Params {
    function?: GetEquipmentConfigurationsWithFilter | null;
}

export interface OPCUAConnect_RF_GetAutomationNodeTypes2Params {
    function?: OPCUAConnect_RF_GetAutomationNodeTypes | null;
}

export interface OPCUAConnect_RF_GetAutomationNodeInstances2Params {
    function?: OPCUAConnect_RF_GetAutomationNodeInstances | null;
}

export interface DeleteEquipmentLevels2Params {
    command?: DeleteEquipmentLevels | null;
}

export interface DeleteEquipmentTypes2Params {
    command?: DeleteEquipmentTypes | null;
}

export interface DeleteEquipmentConfigurations2Params {
    command?: DeleteEquipmentConfigurations | null;
}

export interface DeleteEquipmentGroupConfigurations2Params {
    command?: DeleteEquipmentGroupConfigurations | null;
}

export interface DeleteEquipmentGraphConfigurations2Params {
    command?: DeleteEquipmentGraphConfigurations | null;
}

export interface UpdateEquipmentGraphConfiguration2Params {
    command?: UpdateEquipmentGraphConfiguration | null;
}

export interface AssociateChildrenEquipmentGroupConfWithEquipmentGroupConf2Params {
    command?: AssociateChildrenEquipmentGroupConfWithEquipmentGroupConf | null;
}

export interface AssociateEquipmentConfigurationsWithEquipmentGroupConfiguration2Params {
    command?: AssociateEquipmentConfigurationsWithEquipmentGroupConfiguration | null;
}

export interface SynchronizeEquipmentGraph2Params {
    command?: SynchronizeEquipmentGraph | null;
}

export interface BulkImportEquipmentGraphConfiguration2Params {
    command?: BulkImportEquipmentGraphConfiguration | null;
}

export interface AddEquipmentTypeStateMachines2Params {
    command?: AddEquipmentTypeStateMachines | null;
}

export interface CreateEquipmentStateMachines2Params {
    command?: CreateEquipmentStateMachines | null;
}

export interface DeleteEquipmentTypePropertyAttribute2Params {
    command?: DeleteEquipmentTypePropertyAttribute | null;
}

export interface UpdateEquipmentPropertyAttribute2Params {
    command?: UpdateEquipmentPropertyAttribute | null;
}

export interface SetEquipmentPropertyValue2Params {
    command?: SetEquipmentPropertyValue | null;
}

export interface UnfreezeEquipmentLevel2Params {
    command?: UnfreezeEquipmentLevel | null;
}

export interface FreezeEquipmentType2Params {
    command?: FreezeEquipmentType | null;
}

export interface UpdateEquipmentGraphNode2Params {
    command?: UpdateEquipmentGraphNode | null;
}

export interface UpdateEquipmentGraphLink2Params {
    command?: UpdateEquipmentGraphLink | null;
}

export interface DeleteEquipmentGroupConfiguration2Params {
    command?: DeleteEquipmentGroupConfiguration | null;
}

export interface DisassociateParentsEquipmentGroupConfFromEquipmentGroupConf2Params {
    command?: DisassociateParentsEquipmentGroupConfFromEquipmentGroupConf | null;
}

export interface DeleteEquipmentTypeProperty2Params {
    command?: DeleteEquipmentTypeProperty | null;
}

export interface AssociateParentsEquipmentGroupConfWithEquipmentGroupConf2Params {
    command?: AssociateParentsEquipmentGroupConfWithEquipmentGroupConf | null;
}

export interface UpdateEquipmentConfiguration2Params {
    command?: UpdateEquipmentConfiguration | null;
}

export interface UpdateEquipment2Params {
    command?: UpdateEquipment | null;
}

export interface DisassociateEquipmentGroupConfigurationsFromEquipmentConfiguration2Params {
    command?: DisassociateEquipmentGroupConfigurationsFromEquipmentConfiguration | null;
}

export interface AddEquipmentConfigurationStateMachines2Params {
    command?: AddEquipmentConfigurationStateMachines | null;
}

export interface DisassociateEquipmentConfigurationsFromEquipmentGroupConfiguration2Params {
    command?: DisassociateEquipmentConfigurationsFromEquipmentGroupConfiguration | null;
}

export interface SetEquipmentTypeAsDefault2Params {
    command?: SetEquipmentTypeAsDefault | null;
}

export interface SetEquipmentStatus2Params {
    command?: SetEquipmentStatus | null;
}

export interface FreezeEquipmentLevel2Params {
    command?: FreezeEquipmentLevel | null;
}

export interface DeleteEquipmentStateMachine2Params {
    command?: DeleteEquipmentStateMachine | null;
}

export interface UpdateEquipmentType2Params {
    command?: UpdateEquipmentType | null;
}

export interface UpdateEquipmentGraphType2Params {
    command?: UpdateEquipmentGraphType | null;
}

export interface UpdateHierarchyEquipmentNodeConfiguration2Params {
    command?: UpdateHierarchyEquipmentNodeConfiguration | null;
}

export interface CreateEquipmentLevel2Params {
    command?: CreateEquipmentLevel | null;
}

export interface CreateEquipmentGroupConfiguration2Params {
    command?: CreateEquipmentGroupConfiguration | null;
}

export interface SynchronizeEquipment2Params {
    command?: SynchronizeEquipment | null;
}

export interface CreateEquipment2Params {
    command?: CreateEquipment | null;
}

export interface UpdateEquipmentTypeProperty2Params {
    command?: UpdateEquipmentTypeProperty | null;
}

export interface UpdateEquipmentConfigurationProperty2Params {
    command?: UpdateEquipmentConfigurationProperty | null;
}

export interface UnfreezeEquipmentGroupConfiguration2Params {
    command?: UnfreezeEquipmentGroupConfiguration | null;
}

export interface CreateEquipmentGraphNodeConfiguration2Params {
    command?: CreateEquipmentGraphNodeConfiguration | null;
}

export interface CreateEquipmentGraphType2Params {
    command?: CreateEquipmentGraphType | null;
}

export interface DeleteEquipmentGraphType2Params {
    command?: DeleteEquipmentGraphType | null;
}

export interface UpdateEquipmentLevel2Params {
    command?: UpdateEquipmentLevel | null;
}

export interface UpdateEquipmentTypePropertyAttribute2Params {
    command?: UpdateEquipmentTypePropertyAttribute | null;
}

export interface CreateEquipmentType2Params {
    command?: CreateEquipmentType | null;
}

export interface CreateEquipmentConfiguration2Params {
    command?: CreateEquipmentConfiguration | null;
}

export interface UpdateEquipmentGraphLinkConfiguration2Params {
    command?: UpdateEquipmentGraphLinkConfiguration | null;
}

export interface BulkImportEquipmentHierarchy2Params {
    command?: BulkImportEquipmentHierarchy | null;
}

export interface ForceEquipmentStatus2Params {
    command?: ForceEquipmentStatus | null;
}

export interface SetEquipmentPropertyAttributeValue2Params {
    command?: SetEquipmentPropertyAttributeValue | null;
}

export interface DeleteEquipmentLevel2Params {
    command?: DeleteEquipmentLevel | null;
}

export interface CreateEquipmentGraphLinkConfiguration2Params {
    command?: CreateEquipmentGraphLinkConfiguration | null;
}

export interface FreezeEquipmentConfiguration2Params {
    command?: FreezeEquipmentConfiguration | null;
}

export interface DeleteHierarchyEquipmentNodeConfiguration2Params {
    command?: DeleteHierarchyEquipmentNodeConfiguration | null;
}

export interface UpdateEquipmentGroup2Params {
    command?: UpdateEquipmentGroup | null;
}

export interface CreateHierarchyEquipmentNodeConfigurations2Params {
    command?: CreateHierarchyEquipmentNodeConfigurations | null;
}

export interface SynchronizeEquipmentGroup2Params {
    command?: SynchronizeEquipmentGroup | null;
}

export interface DeleteEquipmentTypeStateMachine2Params {
    command?: DeleteEquipmentTypeStateMachine | null;
}

export interface CreateEquipmentGraphConfiguration2Params {
    command?: CreateEquipmentGraphConfiguration | null;
}

export interface UnfreezeEquipmentConfiguration2Params {
    command?: UnfreezeEquipmentConfiguration | null;
}

export interface DeleteEquipmentType2Params {
    command?: DeleteEquipmentType | null;
}

export interface FreezeEquipment2Params {
    command?: FreezeEquipment | null;
}

export interface AssociateEquipmentGroupConfigurationsWithEquipmentConfiguration2Params {
    command?: AssociateEquipmentGroupConfigurationsWithEquipmentConfiguration | null;
}

export interface CreateEquipmentConfigurationByDefaultEquipmentType2Params {
    command?: CreateEquipmentConfigurationByDefaultEquipmentType | null;
}

export interface UpdateEquipmentProperty2Params {
    command?: UpdateEquipmentProperty | null;
}

export interface UpdateEquipmentGroupConfiguration2Params {
    command?: UpdateEquipmentGroupConfiguration | null;
}

export interface DeleteEquipmentConfigurationPropertyAttribute2Params {
    command?: DeleteEquipmentConfigurationPropertyAttribute | null;
}

export interface DeleteEquipmentConfigurationStateMachine2Params {
    command?: DeleteEquipmentConfigurationStateMachine | null;
}

export interface DeleteEquipmentGraphConfiguration2Params {
    command?: DeleteEquipmentGraphConfiguration | null;
}

export interface DeleteEquipment2Params {
    command?: DeleteEquipment | null;
}

export interface FreezeEquipmentGroupConfiguration2Params {
    command?: FreezeEquipmentGroupConfiguration | null;
}

export interface DeleteEquipmentGraphLinkConfiguration2Params {
    command?: DeleteEquipmentGraphLinkConfiguration | null;
}

export interface DeleteEquipmentPropertyAttribute2Params {
    command?: DeleteEquipmentPropertyAttribute | null;
}

export interface DeleteEquipmentConfiguration2Params {
    command?: DeleteEquipmentConfiguration | null;
}

export interface DeleteEquipmentConfigurationProperty2Params {
    command?: DeleteEquipmentConfigurationProperty | null;
}

export interface UnfreezeEquipmentType2Params {
    command?: UnfreezeEquipmentType | null;
}

export interface DisassociateChildrenEquipmentGroupConfFromEquipmentGroupConf2Params {
    command?: DisassociateChildrenEquipmentGroupConfFromEquipmentGroupConf | null;
}

export interface UpdateEquipmentConfigurationPropertyAttribute2Params {
    command?: UpdateEquipmentConfigurationPropertyAttribute | null;
}

export interface UnfreezeEquipment2Params {
    command?: UnfreezeEquipment | null;
}

export interface DeleteEquipmentGraphNodeConfiguration2Params {
    command?: DeleteEquipmentGraphNodeConfiguration | null;
}

export interface OPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodes2Params {
    command?: OPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodes | null;
}

export interface OPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfiguration2Params {
    command?: OPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfiguration | null;
}

export interface OPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfiguration2Params {
    command?: OPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfiguration | null;
}

export interface OPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentType2Params {
    command?: OPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentType | null;
}

export interface OPCUAConnect_AssociateAutomationNodeTypesWithEquipmentType2Params {
    command?: OPCUAConnect_AssociateAutomationNodeTypesWithEquipmentType | null;
}

export interface SetEquipmentGraphConfigurationAsDefault2Params {
    command?: SetEquipmentGraphConfigurationAsDefault | null;
}
